import { utcDayjs } from "@dashboard-config"
import type { CareerItem, NewsItem, SupportedLocale } from "@site-types/content"

export function getLocalizedNews<T extends Pick<NewsItem, "language" | "publishDate" | "slug">>(
  data: { news: T[] },
  locale: SupportedLocale
): T[] {
  return [...data.news.filter((item) => item.language === locale && item.slug?.current)].sort(
    (a, b) => (utcDayjs(b.publishDate)?.valueOf() ?? 0) - (utcDayjs(a.publishDate)?.valueOf() ?? 0)
  )
}

export function getLocalizedCareers<T extends Pick<CareerItem, "active" | "language" | "slug" | "title">>(
  data: { careers: T[] },
  locale: SupportedLocale
): T[] {
  const seen = new Set<string>()
  return data.careers.filter((item) => {
    const title = item.title ?? item.slug?.current ?? ""
    if (item.language !== locale || item.active === false || !item.slug?.current || seen.has(title))
      return false
    seen.add(title)
    return true
  })
}
